<div class="profile-section">
    <div class="section-header">
        <div class="title-text-header">
            <p>
                {{ title }}
            </p>
            <mat-icon *ngIf="titleTooltip" class="info-icon" matTooltip="{{ titleTooltip }}"> info </mat-icon>
        </div>

        <button mat-icon-button [attr.aria-label]="'Open up the ' + title + ' profile section.'" (click)="toggleCollapsed()">
            <mat-icon [ngClass]="{ collapsed }">keyboard_arrow_up</mat-icon>
        </button>
    </div>
    <div [ngClass]="{ 'section-content': true, collapsed }">
        <ng-content></ng-content>
    </div>
</div>
